import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-geolocation-request-header',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './geolocation-request-header.component.html',
  styleUrls: ['./geolocation-request-header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeolocationRequestHeaderComponent {

}
